/**
 * Initialize the default properties for the state
 * This assumes there is a propertyDefaults object in the state, and will go through each property and assign
 * that property to the Ember Object.
 *
 * @param {Boolean=}    opt_isReturnAsObject      Set to true to return the property as an object instead of setting on this.
 * @param {String=}     opt_propertyBagName       String name of the key for the bag of property items.
 */
export const initializePropertyDefaults = (scope, opt_isReturnAsObject, opt_propertyBagName) => {
  const propertyBagName = opt_propertyBagName || 'propertyDefaults';
  const propertyDefaults = scope[propertyBagName];
  const newProperties = {};

  Object.keys(propertyDefaults).forEach( key => {
    newProperties[key] = (typeof propertyDefaults[key] === 'function') ? propertyDefaults[key]() : propertyDefaults[key];
  });

  if (opt_isReturnAsObject) {
    return newProperties;
  }

  scope.setProperties(newProperties)
}
